import { Form } from "react-final-form";

import Button from "@mui/material/Button";

import { useIntl } from "@mnemonic/intl";
import { extractErrorMessage } from "@mnemonic/redux-utils";

import { LoginBoxActions, LoginBoxCallout } from "../../Components/Login/Layout";
import { PasswordField } from "../../Components/PasswordTextField";
import { useAuthorizeLdapMutation } from "../../Redux/Service/authorizeApi";
import { commonMessages } from "../../commonMessages";
import { redirectToValidatedNextURI } from "../../utils/nextURIRedirect";
import type { TOperation } from "./utils/OperationUtils";
import { redirectWithState } from "./utils/redirectWithState";

interface IFormProps {
  password: string;
}
export interface IUALdapProps {
  context?: { [key: string]: string };
  nextURI: string;
  operation: TOperation;
}

export const AuthorizationWithLDAP = (props: IUALdapProps) => {
  const { operation, context, nextURI } = props;

  const { formatMessage } = useIntl();
  const [authorizeLdap, { isLoading, error }] = useAuthorizeLdapMutation();
  const errorMessage = extractErrorMessage(error);

  return (
    <Form
      initialValues={{ password: null }}
      onSubmit={(formValues: IFormProps, formApi) =>
        authorizeLdap({ criteria: { ...formValues, operation, context, nextURI } })
          .unwrap()
          ?.then(({ data }) => {
            redirectWithState(data);
          })
          // on error reset password field
          ?.catch((error) => {
            formApi.change("password", "");
            console.error(error);
          })
      }
      render={({ handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit}>
            {errorMessage && <LoginBoxCallout type="error">{errorMessage}</LoginBoxCallout>}
            <PasswordField name="password" method="ad3" />
            <LoginBoxActions>
              <div>
                <Button
                  disabled={isLoading}
                  style={{ marginRight: 8 }}
                  onClick={() => void redirectToValidatedNextURI(nextURI)}
                >
                  {formatMessage(commonMessages.Cancel)}
                </Button>
                <Button type="submit" variant="contained" color="secondary" disabled={isLoading}>
                  {formatMessage(commonMessages.Authorize)}
                </Button>
              </div>
            </LoginBoxActions>
          </form>
        );
      }}
    />
  );
};
